// extracted by mini-css-extract-plugin
export var measureBox = "_cm-0";